import { createFileRoute } from "@tanstack/react-router";

import { FisioCompletoPage, FAQ_ITEMS } from "@/components/lps/FisioCompletoPage";

export const Route = createFileRoute("/fisiocompleto")({
  head: () => ({
    meta: [
      { title: "Projeto Fisio Completo | Pós FEO + Star + IA + Certificações" },
      {
        name: "description",
        content:
          "Pós-graduação FEO reconhecida pelo MEC + Star Cursos + Agente IA Fukusawa + certificações em uma condição exclusiva. Fale com o time e garanta sua vaga.",
      },
      { property: "og:title", content: "Projeto Fisio Completo | Pós FEO + Star + IA + Certificações" },
      { property: "og:description", content: "Pós FEO com MEC, Star Cursos, Agente IA Fukusawa e certificações reunidos em uma condição exclusiva. Fale com o time e garanta sua vaga." },
      { property: "og:url", content: "https://fisioemortopedia.com.br/fisiocompleto" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "index,follow" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/fisiocompleto" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ_ITEMS.map((i) => ({
            "@type": "Question",
            name: i.q,
            acceptedAnswer: { "@type": "Answer", text: i.a },
          })),
        }),
      },
    ],
  }),

  component: FisioCompletoRoute,
});

function FisioCompletoRoute() {
  return <FisioCompletoPage mode="captura" />;
}
